module.exports = __webpack_public_path__ + "img/Skirt-Back-B7-Da-Fc-Hc.04328e0c.png";